/**
 *
 * @param node
 * @returns {StoryboardStep}
 */
StoryboardStep.create = function (storyboard) {
    var storyboardStep = new StoryboardStep();

    storyboardStep.__storyboard = storyboard;
    storyboardStep.timestamp = storyboard.maximumTimestamp() != null ? storyboard.maximumTimestamp() + 1000 : 0;
    storyboardStep.label = Utils.getNextDefaultLabel(storyboard.content.timeline, "Step", 1);
    storyboardStep.entries = [];

    return storyboardStep;
};

/**
 *
 * @param node
 * @param storyboardStep
 * @returns {*}
 */
StoryboardStep.bind = function (storyboard, storyboardStep) {
    Utils.inheritMethods(storyboardStep, new StoryboardStep());

    storyboardStep.bind(storyboard);

    return storyboardStep;
};

/**
 *
 */
function StoryboardStep() {
    /**
     *
     */
    StoryboardStep.prototype.bind = function (storyboard) {
        this.__storyboard = storyboard;

        for (var n in this.entries) {
            StoryboardStepEntry.bind(this, this.entries[n]);
        }
    };
}
